import Modal from "../common/Modal";
import Flow from "../common/Flow";
import Typography from "../common/Typography";
import Table from "../common/Table";
import Button from "../common/Button";
import { Tabs, TabItem, TabContent } from "../common/Tabs";
import { useState } from "react";
import { avaragePriceOfShip, format, formatNumber } from "../../utils/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKipSign } from "@fortawesome/pro-light-svg-icons";

function ShipyardModal({ store }) {
  const [tab, setTab] = useState('ships');
  const shipyard = store.state.shipyard;

  return (
    <Modal store={store} $padding>
      <Flow $space={6}>
        <Typography as="h1" fontSize="2xl">Shipyard</Typography>
        <Tabs>
          <TabItem $active={tab == 'ships'} onClick={() => setTab('ships')}>Ships</TabItem>
          <TabItem $active={tab == 'transactions'} onClick={() => setTab('transactions')}>Transactions</TabItem>
        </Tabs>
        {tab == 'ships' &&
          <TabContent>
            <Table $style="striped">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Avarage price</th>
                  <th>Descripion</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {shipyard && shipyard.ships.map((ship, idx) => (
                  <tr key={idx}>
                    <td>{ship.type}</td>
                    <td><FontAwesomeIcon icon={faKipSign} /> {avaragePriceOfShip(ship.type, shipyard.transactions)}</td>
                    <td>{ship.description}</td>
                    <td>
                      <Button $action onClick={() => store.purchaseNewShip(ship.type)}>Purchase ship</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TabContent>
        }
        {tab == 'transactions' && 
          <TabContent>
            <Table $style="striped">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Price</th>
                  <th>Purchased by</th>
                  <th>When purchased</th>
                </tr>
              </thead>
              <tbody>
                {shipyard && shipyard.transactions.map((ship, idx) => (
                  <tr key={idx}>
                    <td>{ship.shipSymbol}</td>
                    <td><FontAwesomeIcon icon={faKipSign} /> {formatNumber(ship.price)}</td>
                    <td>{ship.agentSymbol}</td>
                    <td>{format(ship.timestamp)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TabContent>
        }
      </Flow>
    </Modal>
  );
}

export default ShipyardModal;
